// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"94dd5800","455":"9ecd422f","977":"51db5bed"}[chunkId] + ".chunk.js";
};